import FCL from '@mui/material/FormControlLabel'
import styled from '@mui/material/styles/styled'

export const FormControlLabel = styled(FCL, {
  name: 'FormControlLabel',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})`
  margin: 0;
  display: flex;
`
